// {
// 	"nr": 0,
// 	"tekst": "string"
// }

export interface EmploymentTypeData {
    id: number
    navn: string
    harAnsaettelsesSlutDato: boolean
}

export class EmploymentType {
    id: number

    name: string

    hasEmploymentEndingDate: boolean

    public static build(data: EmploymentTypeData): EmploymentType {
        const employmentType = new EmploymentType()
        employmentType.id = data.id
        employmentType.name = data.navn
        employmentType.hasEmploymentEndingDate = data.harAnsaettelsesSlutDato
        return employmentType
    }
}
